import {
    AdminContentBlock,
    AdminContentSection,
    ApiProductGridType,
    ApiSectionType,
} from '@storefronts/common-types'

/** Strips server-derived/volatile fields that shouldn't affect equality or diff checks. */
export const stripComparableSectionFields = (
    section: AdminContentSection,
): AdminContentSection => {
    if (
        section.type === ApiSectionType.PLP &&
        (section.productGridType === ApiProductGridType.BEST_SELLERS ||
            section.productGridType ===
                ApiProductGridType.OFTEN_BOUGHT_TOGETHER ||
            section.productGridType === ApiProductGridType.RECENTLY_VIEWED ||
            section.productGridType === ApiProductGridType.SHOP_THE_COLLECTION)
    ) {
        const { visibleProducts, ...rest } = section
        return rest
    }

    if (section.type === ApiSectionType.VIDEO_CAROUSEL) {
        const { playlist, ...rest } = section
        return rest
    }

    return section
}

export const transformContentToComparable = (
    content: AdminContentBlock,
): AdminContentBlock => ({
    ...content,
    tabs: content.tabs.map((tab) => ({
        ...tab,
        sections: tab.sections.map(stripComparableSectionFields),
    })),
})
